module.exports = __webpack_public_path__ + "img/speaker-l1.09a4b8ab.jpg";